import BaseTrackingController from "../../../../../shared/src/ranj/equalture/platform/BaseTrackingController";
import InteractionEventName from "../data/InteractionEventName";

export default class TrackingController extends BaseTrackingController {

    constructor(dispatcher) {
        super(dispatcher);
    }


    /**
     * @param {ProgressValue} value 
     * @param {Number} elapsedTime in msecs
     */
    trackProgress(value, elapsedTime) {
        this._dispatchProgressEvent(value, elapsedTime);
    }

    /**
     * @param {Number} levelNumber Number of level, starting at 1
     * @param {Number} elapsedTime 
     */
    trackLevelStart(levelNumber, elapsedTime) {
        this._dispatchInteractionEvent(
            InteractionEventName.LEVEL_STARTED,
            { level: levelNumber },
            elapsedTime
        );
    }

    /**
     * 
     * @param {*} levelNumber Number of level, starting at 1
     * @param {*} spot Spot that the player selected (number)
     * @param {*} elapsedTime 
     */
    trackSpotSelected(levelNumber, spot, elapsedTime) {
        this._dispatchInteractionEvent(
            InteractionEventName.SPOT_SELECTED,
            { 
                level: levelNumber,
                spot: spot 
            },
            elapsedTime
        );
    }

    /**
     * 
     * @param {*} levelNumber Number of level, starting at 1
     * @param {*} spot Spot that the player selected (number)
     * @param {*} elapsedTime 
     */
    trackSpotDeselected(levelNumber, spot, elapsedTime) {
        this._dispatchInteractionEvent(
            InteractionEventName.SPOT_DESELECTED,
            { 
                level: levelNumber,
                spot: spot 
            },
            elapsedTime
        );
    }

    /**
     * 
     * @param {*} levelNumber Number of level, starting at 1
     * @param {*} isCorrect Whether the submission was correct
     * @param {*} sequence What sequence was submitted
     * @param {*} elapsedTime 
     */
    trackLevelSubmitted(levelNumber, isCorrect, sequence, elapsedTime, attempt, submitted_by) {
        this._dispatchInteractionEvent(
            InteractionEventName.LEVEL_SUBMITTED,
            {
                level: levelNumber,
                correct: isCorrect,
                sequence: sequence,
                attempt: attempt,
                submitted_by: submitted_by
            },
            elapsedTime
        );
    }
};
